import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { Input } from "@/components/ui/input";
import Button from "@/components/ui/AppButton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { allowedDomains } from "@/lib/allowedDomains";

function getSafeRedirect(value: string | null) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return "/kanban";
  }
  return value;
}

export default function LoginPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setMessage("");

    const domain = email.split("@")[1];
    if (!allowedDomains.includes(domain)) {
      setMessage("Adresse e-mail non autorisée.");
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setMessage("Erreur : " + error.message);
      setLoading(false);
      return;
    }

    navigate(getSafeRedirect(searchParams.get("redirectTo")), { replace: true });
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#fdfcfb] to-[#e2d1c3]">
      <Card className="w-[400px] shadow-xl border-none">
        <CardHeader>
          <CardTitle className="text-center text-2xl font-semibold text-gray-800">
            Connexion par mot de passe
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <Input
              type="email"
              placeholder="Votre adresse e-mail professionnelle"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <Input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 text-white hover:bg-indigo-700"
            >
              {loading ? "Connexion en cours..." : "Se connecter"}
            </Button>
          </form>
          {message && (
            <p className="mt-4 text-center text-sm text-gray-600">{message}</p>
          )}
          <p className="mt-4 text-center text-sm text-gray-500">
            <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-700">
              Utiliser le lien magique
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
